module.exports = __webpack_public_path__ + "media/audios/kid/lesson_8/audio_tpc8-6054370b14d06fb8dee3635a3faad14c.m4a";